import { Col } from 'reactstrap';
import ComponentCard from '../../layouts/containers/ComponentCard';
import FichaProfesor from '../../components/profesores/FichaProfesor';

const DetallesProfesores = () => {
  return (
    <>
      <Col md="12">
        <ComponentCard title="Detalles de profesores" hasButton>
          <FichaProfesor />
        </ComponentCard>
      </Col>
    </>
  );
};

export default DetallesProfesores;
